<template>  


      <div class="col-12">
          <div class="card border-0">
            <div class="card-header font-weight-bold bg-transparent border-0">Include Details</div>


            <div v-if="loading == 0" class="card-body">
              <div class="col-12 mt-4">
                <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
              </div>
            </div>

            <div v-if="loading == 1" class="card-body pt-0">

              <div class="row">
                <div class="col-9">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Content</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.name }}
                    </div>
                  </div>
                  
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Order</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.order }}
                    </div>
                  </div>
                  
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Status</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.statusName }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Last Modified</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.updated_at | moment("MM/DD/YYYY") }}
                    </div>
                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Creator</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.creatorName }}
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Created</small>
                    </div>
                    <div class="col-12 mb-3">
                      {{ includeDetails.created_at | moment("MM/DD/YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
      
              <div class="row">
                <div class="col-12">
                  <button @click="cancelView" class="btn btn-primary">Close</button>
                  <button @click="editView" class="btn btn-warning">Edit</button>
                  <button @click="deleteInclude" class="btn btn-danger">Delete</button>
                </div>
              </div>

            </div><!--  end card-body -->
          </div><!--  end card -->
      </div>
      


</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../../stores/admin-product-single-main-store.js'




export default {
  props: ['prop1', 'prop2', 'prop3'],
  store,
  data: function () {
    return { 
      loading: 0,
      inc_name: '',
      inc_order: '',
      inc_status: '0',
      includeDetails: [],
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },
    detailsComp () { return this.$store.state.detailsComp },
  },
  watch: {
    prop3() { this.getIncludeDetails(); },
  },
  mounted() {
    this.getIncludeDetails();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    getIncludeDetails() {
      var _this = this;
      _this.loading = 0;
      axios.get('/admin/utility/product/getspecificincludes/' + _this.prop3[0])
        .then(function (response) {
        var a = response.data.data;
        if(a == null || a == ''){ var b = []; } else { var b = a; }
          _this.includeDetails = b;
          _this.loading = 1;
        });
    },
    editView() {
      var _this = this;
      var setup = [1, 'edit-include', _this.prop3[0]];
      _this.$emit('secondaryAction', setup);
    },

    cancelView() {
      var _this = this;
      _this.$emit('onUComplete', [ 'view-include' ])
    },
    deleteInclude() {
      var _this = this;
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.get('/admin/utility/product/includes/delete/' + _this.prop3[0])
          .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', ['delete-include']);
          })
        }
      })
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
    
  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>
